import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Differentials from "@/components/sections/Differentials";
import Reviews from "@/components/sections/Reviews";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="relative min-h-screen bg-[#0A0A0A] text-white overflow-hidden"
    >
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Differentials />
      <Reviews />
      <Contact />
      <Footer />
    </main>
  );
}
